"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Cooltip_1 = require("../Cooltip");
require("./TextInput.scss");
exports.TextInput = function (props) {
    var labelText = props.labelText, name = props.name, isRequired = props.isRequired, placeholder = props.placeholder, value = props.value, defaultValue = props.defaultValue, isTextArea = props.isTextArea, readOnly = props.readOnly, disabled = props.disabled, validationState = props.validationState, errorMessage = props.errorMessage, inputSize = props.inputSize, onChange = props.onChange, onBlur = props.onBlur, labelProps = props.labelProps, inputProps = props.inputProps, children = props.children, rest = __rest(props, ["labelText", "name", "isRequired", "placeholder", "value", "defaultValue", "isTextArea", "readOnly", "disabled", "validationState", "errorMessage", "inputSize", "onChange", "onBlur", "labelProps", "inputProps", "children"]);
    var labelPropsObj = labelProps ? labelProps : {};
    var inputPropsObj = inputProps ? inputProps : {};
    var mergedInputProps = __assign({ value: value, defaultValue: defaultValue, placeholder: placeholder, name: name, onChange: onChange, onBlur: onBlur, disabled: disabled }, inputProps);
    var sizeClass;
    switch (inputSize) {
        case "full":
            sizeClass = "input-lg";
            break;
        case "minimal":
            sizeClass = "input-sm";
            break;
        default:
            sizeClass = null;
    }
    var validationClass = "";
    if (validationState === "invalid") {
        validationClass = "invalid";
    }
    else if (validationState === "valid") {
        validationClass = "valid";
    }
    var divClasses = classNames({ "form-group": true }, props.className);
    var labelClasses = classNames({ "required-input-label": isRequired }, labelPropsObj.className);
    var inputClasses = classNames({ "form-control": true }, validationClass, inputPropsObj.className, sizeClass);
    function handleInputChange(e) {
        if (onChange) {
            onChange(e);
        }
    }
    function handleInputBlur(e) {
        if (onBlur) {
            onBlur(e);
        }
    }
    function wrapInputWithTooltip(el) {
        if (!errorMessage) {
            return el;
        }
        return (React.createElement(Cooltip_1.Cooltip, { placement: "bottom", tooltipContents: errorMessage, tooltipType: 'error', hidden: validationState === "valid" }, el));
    }
    var input;
    // tslint:disable-next-line:prefer-conditional-expression
    if (!isTextArea) {
        input = React.createElement("input", __assign({}, mergedInputProps, { onChange: handleInputChange, onBlur: handleInputBlur, className: inputClasses, type: "text" }, { readOnly: readOnly }));
    }
    else {
        input = React.createElement("textarea", __assign({}, mergedInputProps, { onChange: handleInputChange, onBlur: handleInputBlur, className: inputClasses }, { readOnly: readOnly }));
    }
    var inputComponent = wrapInputWithTooltip(input);
    return (React.createElement("div", __assign({ className: divClasses }, rest),
        React.createElement("label", __assign({}, labelPropsObj, { className: labelClasses, htmlFor: name }), labelText),
        inputComponent));
};
//# sourceMappingURL=TextInput.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@abb/common-ux/dist/components/TextInput/TextInput.js
// module id = 602
// module chunks = 1